export default "/images/performancefinance-badge.png";